module.exports = __webpack_public_path__ + "img/map_2.5d853d77.png";